import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { COLORS, RADIUS, FONT } from "../theme";
import Input from "../components/ui/Input";
import Btn from "../components/ui/Btn";

const STATS = [
  { value: "Selfie", label: "Confirmação por foto" },
  { value: "24/7", label: "Bater ponto" },
  { value: "100%", label: "Digital" },
];

export default function Login() {
  const { login, confirmar2fa } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState(() =>
    new URLSearchParams(window.location.search).get("expirado")
      ? "Sua sessão expirou. Entre novamente."
      : ""
  );
  const [loading, setLoading] = useState(false);
  const [isMob, setIsMob] = useState(window.innerWidth < 760);

  const [tokenTemporario, setTokenTemporario] = useState(null);
  const [codigo, setCodigo] = useState("");

  useEffect(() => {
    const fn = () => setIsMob(window.innerWidth < 760);
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);

  const handleLogin = async () => {
    if (!email || !senha) return;
    setLoading(true);
    setErro("");
    try {
      const data = await login(email, senha);
      if (data.precisa_2fa) {
        setTokenTemporario(data.token_temporario);
        return;
      }
      navigate(data.usuario.perfil === "admin" ? "/admin" : "/");
    } catch {
      setErro("E-mail ou senha inválidos");
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmar2fa = async () => {
    if (!codigo) return;
    setLoading(true);
    setErro("");
    try {
      const data = await confirmar2fa(tokenTemporario, codigo);
      navigate(data.usuario.perfil === "admin" ? "/admin" : "/");
    } catch {
      setErro("Código inválido ou expirado");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ height: "100dvh", overflow: "hidden", display: "flex", fontFamily: FONT }}>
      {!isMob && (
        <div
          style={{
            width: "46%",
            flexShrink: 0,
            position: "relative",
            overflow: "hidden",
            background: `linear-gradient(150deg, ${COLORS.primaryDark} 0%, ${COLORS.primary} 55%, ${COLORS.primaryLight} 100%)`,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ position: "absolute", width: 420, height: 420, borderRadius: "50%", background: "rgba(255,255,255,0.08)", top: -140, right: -120, pointerEvents: "none" }} />
          <div style={{ position: "absolute", width: 260, height: 260, borderRadius: "50%", background: "rgba(255,255,255,0.07)", bottom: 60, left: -70, pointerEvents: "none" }} />

          <div style={{ position: "relative", zIndex: 2, padding: "56px 64px 0", flexShrink: 0 }}>
            <img src={`${process.env.PUBLIC_URL}/logo-pontozipar.png`} alt="PontoZipar" style={{ height: 64, objectFit: "contain" }} />
          </div>

          <div style={{ position: "relative", zIndex: 2, padding: "48px 64px 0", flexShrink: 0 }}>
            <h1 style={{ color: "#fff", fontSize: "clamp(38px, 4.2vw, 56px)", fontWeight: 900, lineHeight: 1.12, margin: "0 0 20px", letterSpacing: "-0.02em" }}>
              Ponto eletrônico
              <br />
              simples e confiável
            </h1>
            <p style={{ color: "rgba(255,255,255,0.85)", fontSize: 18, lineHeight: 1.65, margin: 0, maxWidth: 480 }}>
              Controle entrada, saída e intervalos da sua equipe em qualquer posto de trabalho, com selfie e confirmação de local a cada batida.
            </p>
          </div>

          <div style={{ flex: 1 }} />

          <div style={{ position: "relative", zIndex: 3, flexShrink: 0, display: "flex", gap: 14, padding: "12px 64px 56px" }}>
            {STATS.map((s, i) => (
              <div
                key={i}
                style={{
                  background: "rgba(0,0,0,0.20)",
                  backdropFilter: "blur(12px)",
                  borderRadius: 14,
                  padding: "18px 20px",
                  flex: 1,
                  border: "1px solid rgba(255,255,255,0.22)",
                }}
              >
                <div style={{ color: "#fff", fontWeight: 900, fontSize: 26, lineHeight: 1 }}>{s.value}</div>
                <div style={{ color: "#fff", fontSize: 13.5, marginTop: 7, opacity: 0.85 }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: isMob ? "40px 24px" : "48px 56px",
          background: COLORS.white,
          overflow: "auto",
        }}
      >
        <div style={{ width: "100%", maxWidth: 400 }}>
          <img
            src={`${process.env.PUBLIC_URL}/logo-pontozipar-dark-text.png`}
            alt="PontoZipar"
            style={{ height: isMob ? 56 : 68, objectFit: "contain", display: "block", margin: "0 auto 32px" }}
          />

          <p style={{ fontSize: 11, fontWeight: 700, color: COLORS.primary, textTransform: "uppercase", letterSpacing: "0.12em", margin: "0 0 7px" }}>
            Acesso seguro
          </p>
          <h2 style={{ fontSize: 24, fontWeight: 800, color: COLORS.text, margin: "0 0 5px", letterSpacing: "-0.03em" }}>
            {tokenTemporario ? "Verificação em duas etapas" : "Entrar na plataforma"}
          </h2>
          <p style={{ fontSize: 13, color: COLORS.textMid, margin: "0 0 28px" }}>
            {tokenTemporario
              ? "Abra seu app autenticador e digite o código de 6 dígitos."
              : "Use suas credenciais para continuar"}
          </p>

          {tokenTemporario ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              <Input
                label="Código de verificação"
                value={codigo}
                onChange={(e) => setCodigo(e.target.value.replace(/\D/g, "").slice(0, 6))}
                onKeyDown={(e) => e.key === "Enter" && handleConfirmar2fa()}
                placeholder="000000"
                autoFocus
              />

              {erro && (
                <div
                  style={{
                    color: COLORS.danger,
                    fontSize: 13,
                    background: COLORS.dangerBg,
                    border: "1px solid #FECACA",
                    borderRadius: RADIUS.sm,
                    padding: "9px 13px",
                  }}
                >
                  {erro}
                </div>
              )}

              <Btn onClick={handleConfirmar2fa} disabled={loading} style={{ width: "100%", padding: "14px 18px", marginTop: 4, borderRadius: RADIUS.lg, fontSize: 15 }}>
                {loading ? "Verificando..." : "Confirmar"}
              </Btn>

              <button
                onClick={() => { setTokenTemporario(null); setCodigo(""); setErro(""); }}
                style={{ background: "none", border: "none", color: COLORS.textMid, fontSize: 12.5, cursor: "pointer", padding: 0 }}
              >
                Voltar
              </button>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              <Input
                label="E-mail"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                placeholder="seuemail@empresa.com.br"
                autoFocus
              />
              <Input
                label="Senha"
                type="password"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                placeholder="••••••••"
              />

              {erro && (
                <div
                  style={{
                    color: COLORS.danger,
                    fontSize: 13,
                    background: COLORS.dangerBg,
                    border: "1px solid #FECACA",
                    borderRadius: RADIUS.sm,
                    padding: "9px 13px",
                  }}
                >
                  {erro}
                </div>
              )}

              <Btn onClick={handleLogin} disabled={loading} style={{ width: "100%", padding: "14px 18px", marginTop: 4, borderRadius: RADIUS.lg, fontSize: 15 }}>
                {loading ? "Entrando..." : "Entrar"}
              </Btn>
            </div>
          )}

          <p style={{ marginTop: 28, fontSize: 11, color: COLORS.textLight, textAlign: "center" }}>
            PontoZipar · Ponto eletrônico
          </p>
        </div>
      </div>
    </div>
  );
}
